import React, {Component, useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Select,
    Table,
    Tag,
    Radio,
    Tabs
} from 'antd';
import 'moment/locale/zh-cn';
import moment from "moment";

const {Title, Text} = Typography;
const {Content} = Layout;
const {RangePicker} = DatePicker;
const { TabPane } = Tabs;
function number_chinese(str) {
    var num = parseFloat(str);
    var strOutput = "",
        strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
    num += "00";
    var intPos = num.indexOf('.');
    if (intPos >= 0){
        num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
    }
    strUnit = strUnit.substr(strUnit.length - num.length);
    for (var i=0; i < num.length; i++){
        strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i,1),1) + strUnit.substr(i,1);
    }
    return strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元")

}

const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '单位',
        dataIndex: 'fund_client',
        key: 'fund_client',
    },
    {
        title: '结算期',
        dataIndex: 'fund_date',
        key: 'fund_date',
        render: (fund_date) => <p>{fund_date ? fund_date.substring(0,7) : ''}</p>,
    },
    {
        title: '采购量（吨）',
        dataIndex: 'fund_num',
        key: 'fund_num',
    },
    {
        title: '采购金额（元）',
        dataIndex: 'fund_value',
        key: 'fund_value',
    },
    {
        title: '结算时间',
        dataIndex: 'fund_pubtime',
        key: 'fund_pubtime',
        render: (fund_pubtime) => <p>{fund_pubtime ? fund_pubtime.substring(0,19) : '0.00'}</p>,
    }
];
const Load = (that,start,end) => {

    fetch("http://pd.pokemonbye.com:8087/api/getsellbillbydate?start=" + start + "&end=" + end)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                console.log(array)
                that.setState({
                    isLoaded: true,
                    list: array
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
}

const Load2 = (that,value) => {

    fetch("https://pd.pokemonbye.com:8084/api/getsellfundlikeintroclient?intro=%E7%BB%93%E7%AE%97&client=" + value)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                if(array!=null&&array.length>0){
                    for (let i = 0; i < array.length; i++) {
                        array[i].key = i + 1;
                    }
                }
                that.setState({
                    isLoaded: true,
                    list: array
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
}

class PageFinChecks extends Component {


    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const pid = params.get("area");
        this.state = {
            title: "客户对账单",
            county: [],
            area: pid,
            list: [],
            listman: [],
            listcus: [],
            options: []
        };
    }

    componentDidMount() {


        fetch("https://pd.pokemonbye.com:8084/api/getsellclient")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if(array!=null&&array.length>0){
                        for (let i = 0; i < array.length; i++) {
                            array[i].value = array[i].id;
                            array[i].label = array[i].name;
                        }
                        this.setState({
                            isLoaded: true,
                            options: array
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        const handleChange = (value) => {

            this.setState({
                selid: value
            });
            Load2(this,value);
        };
        const onChange = (date, dateString) => {
            console.log(date, dateString);
            Load(this,dateString[0], dateString[1])
        };
        return (
            <div>
                <Leftmenu/>
                <div className="mainpanel">
                    <Header/>
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Space>
                                    <Select
                                        defaultValue="请选择"
                                        style={{
                                            width: 220,
                                        }}
                                        onChange={handleChange}
                                        options={this.state.options}
                                    />
                            </Space>
                                <br/>
                                <br/>
                                <Table bordered={true} columns={columns} dataSource={this.state.list}/>
                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageFinChecks;


